import {
    Directive,
    Input,
    OnInit,
    TemplateRef,
    ViewContainerRef
} from '@angular/core';
import { Permission } from 'src/app/library/config/auth/permissions/permission';
import { UserAuthService } from '../../auth/services/user.service';

@Directive({
    selector: '[authorized-hide]'
})
export class AuthorizedHideDirective implements OnInit {
    @Input('authorized-hide') permissions: Permission[] | undefined;

    constructor(
        private userAuthService: UserAuthService,
        private viewContainerRef: ViewContainerRef,
        private templateRef: TemplateRef<any>
    ) {}

    ngOnInit() {
        let hasPermission = false;
        if (this.permissions && Array.isArray(this.permissions)) {
            hasPermission = this.userAuthService.hasPermissions(
                this.permissions?.map(String)
            );
        } else
            console.error('Permissions not valid for authorization directive.');

        if (!hasPermission) {
            this.viewContainerRef.clear();
        } else {
            this.viewContainerRef.clear();
            this.viewContainerRef.createEmbeddedView(this.templateRef)
                .rootNodes[0];
        }
    }
}
